import styled from '@emotion/styled';
import Theme from 'App.theme';

export const SetPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;

  a {
    color: ${Theme.colours.black};
    text-decoration: none;
    border-bottom: 2px solid #fff;
    transition: border-bottom 0.3s;

    &:hover {
      border-bottom: 2px solid ${Theme.colours.black};
    }
  }
`;

export const SetHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;

  h1 {
    margin: 0;
  }
`;

export const SetLinksList = styled.div`
  display: flex;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const SetLink = styled.a`
  font-weight: bold;
`;

export const SetButtons = styled.div`
  .MuiButtonBase-root {
    font-size: 14px;
    width: 10rem;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const SetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SetRow = styled.div`
  display: flex;
  gap: 1rem;
`;
